// extracted by mini-css-extract-plugin
module.exports = {"volunteerCards":"VolunteerCards_volunteerCards__2SPaK","cardsContainer":"VolunteerCards_cardsContainer__2b7kC","card":"VolunteerCards_card__1IHMb"};